import React from 'react';
import AdminStats from "../components/AdminStats";
import Navbar from "../../components/base/Navbar";
import Footer from "../../components/base/Footer";

const AdminPanel = ({ onLogout }) => {
    return (
        <div className="bg-gray-200 pt-24 bg-center">

            <Navbar/>

            <div className="mb-48">
                <div className="w-full "></div>

                <h1 className="text-3xl">Admin Panel</h1>

                <div className="w-full m-12"></div>

                <h1 className="text-4xl font-thin">Willkommen Zurück, Admin</h1>

                <div className="w-full m-12"></div>

                <div className="w-full inline-flex text-2xl gap-4">
                    <a className="hover:underline" href="/admin/emails">Email Subscription</a>
                    <a className="hover:underline" href="/admin/blogs">Blog Posts</a>
                    <a className="hover:underline" href="/admin/newsletter">Newsletter</a>
                </div>

                <button className="absolute right-5 top-28 bg-blue-500 rounded-lg py-2 px-5 text-white hover:ring-2"
                        onClick={onLogout}>Logout
                </button>

                <a className="absolute cursor-pointer right-32 top-28 bg-blue-500 rounded-lg py-2 px-5 text-white hover:ring-2"
                   href="/public">Startseite</a>

                <div className="w-full m-12"></div>

                <div className="w-full m-12"></div>

                <AdminStats/>

                <div className="w-full m-12"></div>
            </div>

            <Footer/>
        </div>
    );
};

export default AdminPanel;
